import { Button, DatePicker, Empty, Modal, Space, Tag, Tabs } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import shipperApi from "../../api";

const { RangePicker } = DatePicker;
const rangePresets = [
  {
    label: "Hôm nay",
    value: [dayjs(), dayjs()],
  },
  {
    label: "Hôm qua",
    value: [dayjs().add(-1, "d"), dayjs().add(-1, "d")],
  },
  {
    label: "Tuần này",
    value: [dayjs().startOf("week"), dayjs()],
  },
  {
    label: "Tuần trước",
    value: [
      dayjs().subtract(1, "week").startOf("week"),
      dayjs().subtract(1, "week").endOf("week"),
    ],
  },
  {
    label: "Tháng này",
    value: [dayjs().startOf("month"), dayjs()],
  },
  {
    label: "Tháng trước",
    value: [
      dayjs().subtract(1, "month").startOf("month"),
      dayjs().subtract(1, "month").endOf("month"),
    ],
  },
  {
    label: "Tất cả",
    value: [dayjs("01/07/2023", "DD/MM/YYYY"), dayjs()],
  },
];

export default function TrackingModal({ open, onClose, shipper }) {
  const [range, setRange] = useState([dayjs(), dayjs()]);
  const [logs, setLogs] = useState(null);

  useEffect(() => {
    const getShipperTracking = async () => {
      const data = await shipperApi.getTracking(
        shipper._id,
        range[0].format("YYYY-MM-DD"),
        range[1].format("YYYY-MM-DD")
      );
      if (!data || data.error) {
        toast.error(data.error);
        setLogs(null);
      } else setLogs(data);
    };
    if (shipper) getShipperTracking();
  }, [shipper, range]);

  const onRangeChange = (dates) => {
    setRange(dates);
  };

  // Lọc logs theo field
  const isReadyLogs = logs?.filter((log) => log.field === "isReady") || [];
  const autoAcceptLogs =
    logs?.filter((log) => log.field === "autoAccept") || [];

  const renderLogList = (logList, emptyMessage) => {
    if (logList.length === 0) {
      return <Empty description={emptyMessage} />;
    }

    return (
      <div style={{ maxHeight: 400, overflow: "auto" }}>
        {logList.map((log) => (
          <div key={log._id} style={{ display: "block", marginBottom: "0" }}>
            <Space>
              <Tag color={log.status === "ON" ? "green" : "red"}>
                {log.status === "ON" ? "Bật" : "Tắt"}
              </Tag>{" "}
              <h4>{dayjs(log.createdAt).format("DD/MM/YYYY HH:mm:ss")}</h4>
            </Space>
          </div>
        ))}
      </div>
    );
  };

  const tabItems = [
    {
      key: "isReady",
      label: "Bật tắt nhận đơn",
      children: renderLogList(
        isReadyLogs,
        `Không có dữ liệu log bật/tắt nhận đơn của ${shipper?.name} trong thời gian này!`
      ),
    },
    {
      key: "autoAccept",
      label: "Bật tắt auto nhận đơn",
      children: renderLogList(
        autoAcceptLogs,
        `Không có dữ liệu log bật/tắt auto nhận đơn của ${shipper?.name} trong thời gian này!`
      ),
    },
  ];

  return (
    <>
      <Modal
        open={open}
        onCancel={onClose}
        title="Lịch sử Bật/Tắt nhận đơn"
        footer={[
          <Button type="primary" key="back" onClick={onClose}>
            OK
          </Button>,
        ]}
        width={800}
      >
        <RangePicker
          presets={rangePresets}
          value={range}
          onChange={onRangeChange}
        />
        <br />
        <br />
        <Tabs defaultActiveKey="isReady" items={tabItems} />
      </Modal>
    </>
  );
}
